import { render } from "./ParticipantSearch.vue?vue&type=template&id=1845af5a&ts=true"
import script from "./ParticipantSearch.vue?vue&type=script&lang=ts"
export * from "./ParticipantSearch.vue?vue&type=script&lang=ts"

import "./ParticipantSearch.vue?vue&type=style&index=0&id=1845af5a&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__